import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { heroMasked } from '../../../../assets/figma';

import { heroStyles as styles } from './Hero.styles';

/**
 * Hero — Figma 136:38330 (1380×664, text at 132×89).
 * Uses the pre-masked photo (already cropped to the hero's ~0.48 ratio),
 * clipped with the exact cornerRadius 20 from the Mask group.
 */
export function Hero() {
  return (
    <Box component="section" sx={styles.root} aria-labelledby="hero-heading">
      <Box component="img" src={heroMasked} alt="" sx={styles.media} />
      <Box sx={styles.scrim} />
      <Box sx={styles.container}>
        <Typography id="hero-heading" component="h1" sx={styles.titleLine}>
          Transform your impact to{' '}
          <Box component="br" sx={styles.forcedBreak} />
          build{' '}
          <Box component="span" sx={styles.titleAccent}>
            generational wealth.
          </Box>
        </Typography>
        <Typography component="p" sx={styles.lede}>
          At 530A Solutions®, we believe the path to financial freedom starts
          early.{' '}
          <Box component="br" sx={styles.forcedBreak} />
          That&apos;s why we&apos;re building tools to empower philanthropy to invest
          in children&apos;s savings.
        </Typography>
      </Box>
    </Box>
  );
}
